import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'campaign-payment-page',
    templateUrl: 'campaign-payment-page.html'
})
export class CampaignPaymentPage implements OnInit {
    constructor() { }
    ngOnInit() { }
}